var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var transformMetaplexToken = function (nft, additionalData, decimalsMap) {
    var _a;
    return __assign({ name: nft.name, symbol: nft.symbol, logoURI: (_a = nft.metadata.image) !== null && _a !== void 0 ? _a : null, address: nft.mint.toString(), decimals: decimalsMap[nft.mint.toString()] || 6 }, additionalData);
};
